import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant.js'
import officialAccountsDialog from '@/components/officialAccountsDialog/officialAccountsDialog.vue'
import {
    getUserInfo
} from '@/models/appInfo'
import {
    getLoginInfo
} from '@/utils/loginInfo'
// import { toQueryObject } from '../../utils/util'
export default {
    name: viewName.user,
    // inject: ['reloaded'],
    components: {
        'oa-Dialog': officialAccountsDialog
    },
    data () {
        return {
            user: ''
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            appInfo: ({
                appInfo
            }) => appInfo,
            wxUserInfo: ({ appInfo }) => appInfo.wxUserInfo
        })
    },
    watch: {
        wxUserInfo (newValue, oldValue) {
            this.user = newValue
        }
    },
    created () {
        // if (this.isWeixin) {
        //     this.getWxUserInfo(this.$route.query.code || '').then(res => {
        //         this.user = res
        //         const _thisPath = this.$route.path
        //         let _thisQuery = this.$route.query
        //         _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
        //     })
        // }
    },
    async activated () {
        this.setTitle()
    },
    mounted () {
        this.setTitle()
        // this.user = await getUserInfo({
        //     isWeixin: this.isWeixin ? 1 : 0
        // })
        if (this.$route.query.source === 'pay') {
            this.showTips()
        }
        this.getUserInfo()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'loginOut',
            'verifyUserInfo',
            'getWxUserInfo'
        ]),
        setTitle () {
            this.setAppClass({
                isAppend: false,
                className: 'bgGreyColor'
            })
            this.$emit('setHeader', {
                title: '我的',
                showHeader: true,
                showLeft: true,
                customStyleProps: {
                    background: '#fc2d2d',
                    color: '#ffffff'
                }
            })
        },
        showTips () {
            // 判断是否已经登陆le
            if (getLoginInfo()['token']) {
                // 2. 验证是否已经
                this.$refs.oaDialog && this.$refs.oaDialog.open()
            } else {
                this.verifyUserInfo()
            }
        },
        async getUserInfo () {
            if (this.isWeixin) {
                let user_info = getLoginInfo()
                // 直接获取用户信息
                if (user_info) {
                    this.user = user_info
                }
            } else {
                this.user = await getUserInfo({
                    isWeixin: this.isWeixin ? 1 : 0
                })
            }
        },
        login () {
            this.verifyUserInfo()
        },
        // 登出
        onloginOut (e) {
            e.preventDefault()
            setTimeout(() => {
                this.loginOut()
                this.$router.replace({
                    name: 'user'
                })
                this.user = ''
            }, 300)
            // deleteLoginInfo()
            // this.reloaded()
            // this.getUserInfo()
            // this.$router.go(0)
        },
        toHome () {
            const { activity_id, source } = this.$route.query
            if (typeof (activity_id) !== 'undefined') {
                this.$router.push(`/seckill?activity_id=${activity_id}&sstore_id=0`)
                return
            }

            if (source === 'advice' || source === 'addGoods' || source === 'changeGoods') {
                const ADVICE_HREF = sessionStorage.getItem('ADVICE_HREF')
                window.location.href = ADVICE_HREF
                return
            }

            this.$router.push({
                name: 'home'
            })
        },
        // 点击头像在微信环境下，判断用户授权登录之后又没有手机号。没有手机号跳转到绑定手机号页面
        clickUserImg () {
            if (this.isWeixin) {
                if (this.appInfo.wxUserInfo.phone_number || this.user.phone_mob) {
                    return false
                } else {
                    this.$router.push({
                        name: 'bindingPhone'
                    })
                }
            } else {
                return false
            }
        }
    },
    destroyed () {
        this.$emit('setHeader', {
            showHeader: true,
            showLeft: true,
            customStyleProps: {
                background: '#fff',
                color: '#333'
            }
        })
    }
}
